import { constants } from './config';
import { getEngagements } from './helper';

export function dispatchEvent(action, data) {
  switch(action) {
    case constants.LOG_EVENT_CLICK_MANUAL: return logEventClickManual(data);
    // case constants.LOG_EVENT_CLICK_AUTO: return logEventClickAuto(data);
    // case constants.LOG_EVENT_CLICK_PREVIEW: return logEventClickPreview(data);
    case constants.LOG_EVENT_ENGAGEMENT: return logEventEngagement(data);

    case constants.LOG_EVENT_TAG_OPEN: return logEventTagOpen(data);
    case constants.LOG_EVENT_TAG_CLOSE: return logEventTagClose(data);

    case constants.LOG_EVENT_UNIQUE: return logEventUnique();
    case constants.LOG_EVENT_UNIQUE_2SEC: return logEventUnique2Sec();
    case constants.LOG_EVENT_VIEW: return logEventView(data);

    case constants.LOG_EVENT_PLAY: return logEventPlay(data);
    case constants.LOG_EVENT_PAUSE: return logEventPause(data);
    case constants.LOG_EVENT_FF: return logEventFF(data);
    case constants.LOG_EVENT_VOLUME: return logEventVolume(data);
    case constants.LOG_EVENT_FOCUS_OUT: return logEventFocusOut();
    case constants.LOG_EVENT_FOCUS_IN: return logEventFocusIn();
    case constants.LOG_EVENT_CONTINUE: return logEventContinue(data);
    case constants.LOG_EVENT_REPEAT: return logEventRepeat(data);

    case constants.LOG_EVENT_EMOJI_CLICK: return logEmojiClick(data);
    case constants.LOG_EVENT_COMPLETION: return logVideoCompletion(data);
    case constants.LOG_EVENT_QUARTILE: return logEventQuartile(data);
    case constants.LOG_EVENT_INTERACTING: return logEventInteracting(data);
    // case constants.LOG_EVENT_INTERACTION_START: return logEventInteractionStart(data);
    case constants.LOG_EVENT_ENDCARD_PREVIEW: return logEventEndcardPreview(data);

    case constants.LOG_EVENT_INTERACTION: return logEventInteraction(data);
    case constants.LOG_EVENT_GALLERY_INTERACTION: return logEventGalleryInteraction(data);
    case constants.LOG_EVENT_FORM_INSIGHT: return logEventFormInsight(data);
  }
}

function getTagType(tag) {
  const engagements = tag && getEngagements(tag);
  let engagement = engagements && engagements[0];
  const tag_type = (engagement && engagement.slug) || '';
  return tag_type;
}

function logEventInteraction(data={}) {
  const { tag } = data;
  let tag_id = tag && tag.id;
  let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  let duration = Math.round(data.current_duration);
  delete data.tag;
  return {
    event: 'interaction',
    type: 'interaction',
    tag_id,
    tag_label,
    duration,
    event_type: 'preview',
    tag_type: getTagType(tag),
    ...data
  }
}

function logEventFormInsight(data={}) {
  const { tag } = data;
  let tag_id = tag && tag.id;
  let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  let duration = Math.round(data.current_duration);
  delete data.tag;
  return {
    event: 'form_insight',
    type: 'form_insight',
    tag_id,
    tag_label,
    duration,
    event_type: 'form_insight',
    tag_type: getTagType(tag),
    ...data
  }
}

function logEventGalleryInteraction(data={}) {
  const { tag } = data;
  let tag_id = tag && tag.id;
  let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  let duration = Math.round(data.duration || data.current_duration);
  delete data.tag;
  return {
    event: 'gallery_interaction',
    tag_id,
    tag_label,
    duration,
    event_type: data.event_type || 'preview',
    tag_type: getTagType(tag),
    ...data,
  }
}

function logEventClickManual(data) {
  let tag = data.tag;
  let current_duration = data.current_duration;
  let tag_id = tag && tag.id;
  let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  let evtObject = {
    type: 'click',
    event: 'click',
    click_type: 'manual',
    current_duration,
    tag_type: getTagType(tag),
  };

  if (typeof tag !== 'undefined') {
    evtObject['tag_id'] = tag_id;
    evtObject['tag_label'] = tag_label;
  }

  if (data.info) {
    evtObject['event_type'] = 'info';
  }

  if (data.options && typeof data.options === 'object') {
    evtObject = {...evtObject, ...data.options}
  }

  return evtObject;
}

// function logEventClickAuto(data) {
//   let tag = data.tag;
//   let current_duration = data.current_duration;
//   let tag_id = tag.id;
//   let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
//   let evtObject = {
//     type: 'click',
//     event: 'click',
//     click_type: 'auto',
//     current_duration,
//     tag_id,
//     tag_label,
//   };

//   if (data.info) {
//     evtObject['event_type'] = 'info';
//   }

//   return evtObject;
// }

function logEventEndcardPreview({ current_duration, event_type }) {
  return {
    type: 'end_card_preview',
    sub_type: null,
    event: 'end_card_preview',
    event_type,
    current_duration,
  };
}

// function logEventClickPreview(data) {
//   let tag = data.tag;
//   let current_duration = data.currentTime;
//   let tag_id = tag && tag.id;
//   let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);

//   return {
//     type: 'click',
//     sub_type: null,
//     event: 'click',
//     click_type: 'manual',
//     event_type: data.event_type || 'preview',
//     current_duration,
//     tag_id,
//     tag_label
//   };
// }

function logEventEngagement(data) {
  let tag = data.tag;
  const engagements = tag && getEngagements(tag);
  let engagement = engagements && engagements[0];

  let actionValueFormtted = engagement && engagement.slug;
  let tag_id = tag && tag.id;
  let tag_label = tag && (tag.details.preview_title || tag.details.title);
  let engagement_id = engagement && engagement.id;
  let engagement_label = engagement && engagement[`label|${engagement.slug}`];
  const engagement_type = data.engagement_type;

  return Object.assign({
    type: actionValueFormtted,
    sub_type: null,
    event: 'engagement',
    event_type: actionValueFormtted,
    tag_id,
    tag_label,
    engagement_id,
    engagement_label,
    engagement_type,
    tag_type: getTagType(tag),
  }, data.options || {});
}

function logEventTagOpen(data) {
  let tag = data.tag;
  let tag_id = tag.id;
  let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
  let duration = Math.round(data.duration);

  return {
    type: 'tag',
    sub_type: null,
    event: 'tag',
    event_type: 'open',
    duration,
    tag_id,
    tag_label
  };
}

function logEventTagClose(data) {
  let tag = data.tag;
  let tag_id = tag.id;
  let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
  let duration = data.duration;

  return {
    type: 'tag',
    sub_type: null,
    event: 'tag',
    event_type: 'close',
    duration,
    tag_id,
    tag_label,
    current_duration: data.current_duration
  };
}

function logEventUnique() {
  return {
    type: 'unique_view',
    sub_type: null,
    event: 'unique_view',
    event_type: null,
  };
}

function logEventUnique2Sec() {
  return {
    type: 'unique_2sec_view',
    sub_type: null,
    event: 'unique_2sec_view',
    event_type: null,
  }
}

function logEventView({ current_duration, percent_value }) {
  return {
    type: 'view',
    subtype: null,
    event: 'view',
    current_duration,
    percent_value,
    // duration: 5,
    duration: Math.round(current_duration)
  };
}

function logEventPlay(current_duration) {
  return {
    type: 'player_control',
    subtype: 'play',
    event: 'player',
    event_type: 'play',
    current_duration,
  };
}

function logEventPause(current_duration) {
  return {
    type: 'player_control',
    subtype: 'pause',
    event: 'player',
    event_type: 'pause',
    current_duration,
  };
}

function logEventFF(current_duration) {
  return {
    type: 'player_control',
    subtype: 'ff',
    event: 'player',
    event_type: 'ff',
    current_duration,
  };
}

function logEventVolume(current_duration) {
  return {
    type: 'player_control',
    subtype: 'volume',
    event: 'player',
    event_type: 'volume',
    current_duration,
  };
}

function logEventFocusOut(current_duration) {
  return {
    type: 'player_control',
    subtype: 'focus_out',
    event: 'player',
    event_type: 'focus_out',
    current_duration,
  };
}

function logEventFocusIn(current_duration) {
  return {
    type: 'player_control',
    subtype: 'focus_in',
    event: 'player',
    event_type: 'focus_in',
    current_duration,
  };
}

function logEventContinue(current_duration) {
  return {
    event: 'player',
    event_type: 'continue',
    current_duration,
  };
}

function logEventRepeat(current_duration) {
  return {
    event: 'repeat_view',
    event_type: null,
    current_duration,
  };
}

function logEmojiClick(data) {
  return {
    event: data.event || 'emoticons',
    event_type: data.emoji,
    current_duration: data.current_duration,
  }
}

function logVideoCompletion(data) {
  return {
    event: data.event || 'completion',
    event_type: data.event_type || 'completion',
    current_duration: data.current_duration,
  }
}

function logEventQuartile(data) {
  const { current_duration, event_type, type='quartile', event='quartile', tag } = data;
  let eventObj = {
    type,
    event_type,
    subtype: null,
    event,
    current_duration,
  };
  if (tag) {
    const { video_id, parent_video_id, engagementId, engagementLabel, tagLabel, tagId } = data;
    let subcategory = tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
    let engagement = subcategory && subcategory.engagements && subcategory.engagements[0];

    let actionValueFormtted = engagement && engagement.slug;
    let tag_id = tagId || tag.id;
    let tag_label = tagLabel || tag.details.preview_title || tag.details.title;
    let engagement_id = engagementId || engagement && engagement.id;
    let engagement_label = engagementLabel || engagement && engagement[`label|${actionValueFormtted}`];

    eventObj = { ...eventObj, tag_id, tag_label, engagement_id, engagement_label, video_id, parent_video_id };
  }

  return eventObj;
}

function logEventInteracting(data) {
  let tag = data.tag;
  let tag_id = tag.id;
  let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
  let duration = Math.round(data.duration);
  return {
    type: 'interacting',
    event: 'interacting',
    tag_id,
    tag_label,
    duration,
    current_duration: data.current_duration,
    tag_type: getTagType(tag),
  }
}

// function logEventInteractionStart(data) {
//   let tag = data.tag;
//   let tag_id = tag.id;
//   let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
//   let duration = Math.round(data.duration);

//   return {
//     type: 'interaction_start',
//     sub_type: null,
//     event: 'interaction_start',
//     event_type: 'interaction_start',
//     duration,
//     tag_id,
//     tag_label
//   };
// }



// WEBPACK FOOTER //
// ./components/events.js